import invariant from 'invariant';
import { useEffect } from 'react';
import { useTheme } from '@signavio/ui';
function CSSVariablesProvider({
  children
}) {
  const {
    color
  } = useTheme();
  useEffect(() => {
    const root = document.documentElement;
    invariant(root, 'CSS variables provider needs documentElement to be defined.');
    createCSSVariables(root, color);
  }, [color]);
  return children;
}
function createCSSVariables(rootElement, colors, parentKey = '--color') {
  Object.entries(colors).forEach(([key, value]) => {
    if (typeof value === 'string') {
      rootElement.style.setProperty(`${parentKey}-${key}`, value);
    } else {
      createCSSVariables(rootElement, value, `${parentKey}-${key}`);
    }
  });
}
export default CSSVariablesProvider;